import "./art_carousel.scss";

import { ArtPieceDetails } from "@components/art_piece_details/art_piece_details";
import { ImageUnavailable } from "@components/image_unavailable/image_unvailable";
import * as types from "@root/types";
import { backgroundImageStyle } from "@services/background_image.service";
import React, { FC } from "react";

interface ArtWindowProps {
  artPiece: types.ArtPiece;
}

const ArtWindow: FC<ArtWindowProps> = ({ artPiece }) => {
  if (!artPiece.imageUrls.original) {
    return <ImageUnavailable />;
  }

  const imageUrl = artPiece.imageUrls.original;
  const imageStyle = backgroundImageStyle(imageUrl, {
    backgroundSize: "contain",
  });

  const artPieceImageLabel = `${artPiece.title} by ${artPiece.artistName}`;
  return (
    <div className="art-window">
      <div className="art-window-image--container">
        <div
          role="image"
          aria-label={artPieceImageLabel}
          className="art-window-image"
          style={imageStyle}
        ></div>
      </div>
      <div className="art-window-info--container">
        <ArtPieceDetails artPiece={artPiece} />
      </div>
    </div>
  );
};

export { ArtWindow, ArtWindowProps };
